var map = {
	"./Collectives_AI_And_Fighting_Greed.md.txt": 200,
	"./Makerspace_Sustainability_and_Accessibility.md": 1122,
	"./Makerspace_Sustainability_and_Accessibility.png": 3177,
	"./Thus_Spoke_Bapa.jpg": 3718,
	"./Thus_Spoke_Bapa.md": 5047,
	"./Why_Rotoforge.md.txt": 7819,
	"./Working_Towards_a_Gentler_Future.md": 5785,
	"./letters_to_bapa.md": 5967,
	"./test.jpg": 5398,
	"./test.txt": 1966
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 1844;